import { Component, OnInit, ViewChild, viewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoModalComponent, PoTableAction, PoTableColumn, PoNotificationService } from '@po-ui/ng-components';
import { defaultFiltroProcessoValidacaoClienteFornecedor, FiltroProcessoValidacaoClienteFornecedor, ProcessoValidacaoClienteFornecedor, ProcessoValidacaoClienteFornecedorHistorico } from '../interface/processo-validacao-cliente-fornecedor';
import { ProcessoCadastroService } from '../service/processo-cadastro';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-validacao-cliente-fornecedor',
  templateUrl: './validacao-cliente-fornecedor.component.html',
  styleUrl: './validacao-cliente-fornecedor.component.css'
})
export class ValidacaoClienteFornecedorComponent implements OnInit {

  tipoCadastro: string = '';
  filtroPrincipal: FiltroProcessoValidacaoClienteFornecedor = defaultFiltroProcessoValidacaoClienteFornecedor();

  public readonly poTableColumnsPrincipal: Array<PoTableColumn>;
  public readonly poTableActionsPrincipal: Array<PoTableAction>;
  tabelaPrincipalItems: Array<ProcessoValidacaoClienteFornecedor> = [];

  public readonly poTableColumnsHistorico: Array<PoTableColumn>;
  tabelaHistoricoItems: Array<ProcessoValidacaoClienteFornecedorHistorico> =[];

  historicoAlias: string = '';
  historicoChave: string = '';
  historicoCliFor: string = '';
  textAreaHistorico: string = '';

  informacoesCliFor: string = '';
  informacoesRecno: number = 0;
  informacoesCadastro: string = '';
  justificativaDesbloqueio: string = '';
  justificativaBloqueio: string = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private poNotificationService: PoNotificationService,
    private processoCadastroService: ProcessoCadastroService,
  ){

    this.poTableColumnsPrincipal = [
      { property: 'CCODIGO'     , label: 'Código'   , width: '15%' },
      { property: 'CLOJA'       , label: 'Loja'     , width: '15%' },
      { property: 'CNOMEREDUZ'  , label: 'Nome'     , width: '50%' },
      { property: 'CCGC'        , label: 'CNPJ/CPF' , width: '15%' }
    ];

    this.poTableActionsPrincipal = [
      { label: 'Histórico'    , icon: 'po-icon-history'   , action: this.btnActionHistorico.bind(this) },
      { label: 'Bloquear'     , icon: 'po-icon-lock'      , action: this.btnActionBloquear.bind(this) },
      { label: 'Desbloquear'  , icon: 'po-icon-lock-off'  , action: this.btnActionDesbloquear.bind(this) },
    ];

    this.poTableColumnsHistorico = [
      { property: 'CZGXUSUARI'  , label: 'Usuário'  , width: '15%' },
      { property: 'DZGXDATA'    , label: 'Data'     , width: '15%' , type: 'date' , format: 'dd/MM/yyyy'},
      { property: 'CZGXHORA'    , label: 'Hora'     , width: '15%' },
      { property: 'CZGXTITULO'  , label: 'Título'   , width: '55%' }
    ];

  };

  @ViewChild('modalVisualizarHistorico' , { static: true }) modalVisualizarHistorico!: PoModalComponent;
  @ViewChild('modalDesbloquearCadastro' , { static: true }) modalDesbloquearCadastro!: PoModalComponent;
  @ViewChild('modalBloquearCadastro'    , { static: true }) modalBloquearCadastro!: PoModalComponent;
  @ViewChild('formDesbloqueio'          , { static: true }) formDesbloqueio!: NgForm;

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Validação de Cadastro'},
    ],
  };

  ngOnInit(): void {
    this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_AVALIA_CLIFOR_MENU']).then((temPermissao) => {
      if(temPermissao){
        this.activatedRoute.params.subscribe({
          next : (params) => {
            if ('CCODIGO' in params && 'CLOJA' in params && 'CCADASTRO' in params) {
              this.tipoCadastro               = params.CCADASTRO==='1'?'Cliente':'Fornecedor';
              this.filtroPrincipal.CCODIGO    = params.CCODIGO;
              this.filtroPrincipal.CLOJA      = params.CLOJA;
              this.filtroPrincipal.CCADASTRO  = params.CCADASTRO;
              this.buscaRegistros();
            } else {
              this.validaCadastro()
            }
          }, error: () => {
            this.goHome();
          }
        })
      } else {
        this.poNotificationService.warning("Usuário sem permissão para acessar a rotina!");
        this.goHome();
      }
    });
  };

  buscaRegistros(): void {
    this.tabelaPrincipalItems = [];
    this.processoCadastroService.getAvaliaCadastroCliFor(this.filtroPrincipal).subscribe((ret) => {
      this.tabelaPrincipalItems = ret.items
    });
  };

  btnActionHistorico(row: ProcessoValidacaoClienteFornecedor): void {
    this.limpaInformacoes()

    this.processoCadastroService.getHistoricoCadastroCliFor(row).subscribe((re) => {
      this.tabelaHistoricoItems = re.itemshist
      this.historicoAlias = row.CCADASTRO==='1'?'SA1':'SA2'
      this.historicoChave = row.CCODIGO+row.CLOJA
      this.historicoCliFor = row.CCODIGO+"/"+row.CLOJA
    })

    this.modalVisualizarHistorico.open();
  };

  registroHistoricoSelecionado(registro: ProcessoValidacaoClienteFornecedorHistorico): void {
    this.textAreaHistorico = '';
    this.textAreaHistorico = registro.CZGXHISTOM.trim();
  };

  btnActionDesbloquear(row: ProcessoValidacaoClienteFornecedor): void {
    this.informacoesCliFor = row.CCODIGO+"/"+row.CLOJA+" - "+row.CNOMEREDUZ
    this.informacoesRecno = row.NRECNO
    this.informacoesCadastro = row.CCADASTRO
    this.justificativaDesbloqueio = '';
    this.modalDesbloquearCadastro.open();
  };

  btnActionBloquear(row: ProcessoValidacaoClienteFornecedor): void {
    this.informacoesCliFor = row.CCODIGO+"/"+row.CLOJA+" - "+row.CNOMEREDUZ
    this.informacoesRecno = row.NRECNO
    this.informacoesCadastro = row.CCADASTRO
    this.justificativaBloqueio = '';
    this.modalBloquearCadastro.open();
  };

  confirmarDesbloqueio(): void {
    this.processoCadastroService.postDesbloquearCadastroCliFor(this.informacoesRecno, this.informacoesCadastro, this.justificativaDesbloqueio).subscribe({
      next: () => {
        this.poNotificationService.success("Registro desbloqueado com sucesso!");
        this.validaCadastro()
        this.limpaInformacoes();
        this.modalDesbloquearCadastro.close()
        this.buscaRegistros();
      }
    });
  };

  confirmarBloqueio(): void {
    this.processoCadastroService.postBloquearCadastroCliFor(this.informacoesRecno, this.informacoesCadastro, this.justificativaBloqueio).subscribe({
      next: () => {
        this.poNotificationService.success("Registro Bloqueado com sucesso!");
        this.validaCadastro()
        this.limpaInformacoes();
        this.modalBloquearCadastro.close()
        this.buscaRegistros();
      }
    });
  };

  limpaInformacoes(): void {
    this.tabelaHistoricoItems = [];
    this.historicoAlias = '';
    this.historicoChave = '';
    this.historicoCliFor = '';
    this.textAreaHistorico = '';
    this.informacoesRecno = 0;
    this.informacoesCadastro = '',
    this.informacoesCliFor = ''
    this.justificativaDesbloqueio = ''
    this.justificativaBloqueio = ''
  };

  formDesbloqueioValid(): boolean{
    return (this.justificativaDesbloqueio.trim() === '' || this.justificativaDesbloqueio.trim().length < 10 );
  }

  formBloqueioValid(): boolean{
    return (this.justificativaBloqueio.trim() === '' || this.justificativaBloqueio.trim().length < 10 );
  }

  validaCadastro(): void {
    this.tipoCadastro = this.filtroPrincipal.CCADASTRO==='1'?'Cliente':'Fornecedor'
  };

  goHome(): void {
    this.router.navigateByUrl('')
  };

}
